export default __webpack_public_path__ + "static/media/045-king ezanas stela.35e75d6e.svg";